import { PServed, useIM } from '@wui/im'
import { computed, ref, watch } from 'vue'

import { useStoreLastReadEventIds } from '@/entities/room'

const lockedChats = ref<Set<PServed>>(new Set())

export const useMarkUnread = (pServed: PServed) => {
  const { getMarkedUnread } = useStoreLastReadEventIds()
  const { unMarkAsRead, deleteUnMarkAsRead } = useIM()

  const isEventsReadingLocked = computed(() => lockedChats.value.has(pServed))
  const markedUnread = computed(() => getMarkedUnread(pServed))

  const onMarkAsUnread = async (eventId: number) => {
    const res = await unMarkAsRead({
      to: pServed,
      eventId,
    })
    if (res) {
      lockedChats.value.add(pServed)
      const stopWatch = watch(markedUnread, (v) => {
        if (!v) {
          lockedChats.value.delete(pServed)
          stopWatch()
        }
      })
    }
  }

  const onDeleteMarkAsUnread = async (eventId: number) => {
    await deleteUnMarkAsRead({
      to: pServed,
      eventId,
    })
    lockedChats.value.delete(pServed)
  }

  const unlockMarkedUnread = () => {
    lockedChats.value.delete(pServed)
  }

  return {
    isEventsReadingLocked,
    unlockMarkedUnread,
    onMarkAsUnread,
    onDeleteMarkAsUnread,
  }
}
